import React from 'react'

import { Pane } from 'components/shared/Pane/Pane'

import { useInternalState } from './hooks'

export const Templates = () => {
  const { activeTab, detail, id, tab, tabs, handleTabChange } =
    useInternalState()

  if (id) {
    return detail
  }

  return (
    <Pane tagName="section">
      <Pane.TabsBar onClick={handleTabChange} {...{ activeTab, tabs }} />
      {tab}
    </Pane>
  )
}
